import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';


class SessionCheck extends Component {

  constructor(props) {
    super(props);
    this.state = {
      LanguageStatus: true,
      Language: '',
      Url: '',
      checked: true,
      agencyData: [],
      agentOptions: [],
      filterData: [],
      showModal: false,
      agentName: null,
      selectedAgent: null,
      organizationId: null,
      agencyId: null,
      agencyName: null,
      commissionGroupCode: null,
      chain: null,
      loadingModel: false,
      isTimerStart: false,
      sessionExpiry: document.getElementById('sessionTimeout').getAttribute('value'),
      sessionPopBeforeTime: document.getElementById('sessionPopUpTime').getAttribute('value'),
      timOutSeconds: 120,
      seconds: 120,
      time: {},
      idleTime: 0,
      lastaccessTime: 0,
      showDimmer: false
    }

    this.timer = 0;
    this.signOutTimeOutFunction = null;
    this.keepALiveFunctionInterval = null;
    this.showPopupFunctionInterval = null;
    this.closeModal = this.closeModal.bind(this)
    this.showModal = this.showModal.bind(this)
    this.extendSession = this.extendSession.bind(this)
    this.signOut = this.signOut.bind(this)
    this.countDown = this.countDown.bind(this);
    this.resetIdleTime = this.resetIdleTime.bind(this)
    this.okClick = this.okClick.bind(this)
    this.idleInterval = this.idleInterval.bind(this)
    this.checkIfIdle = this.checkIfIdle.bind(this)
    this.keepAlive = this.keepAlive.bind(this)
    this.showPopUpInterval = this.showPopUpInterval.bind(this)
    this.escFunction = this.escFunction.bind(this);

  }


  componentDidMount() {


    // setTimeout(() => this.setState({ showModal: true, isTimerStart: true }), 1000);

    // this.timer = setInterval(this.countDown, 1000);

    this.setState({ lastaccessTime: Math.floor(new Date().getTime() / 1000) }, () => {

      this.keepALiveFunctionInterval = setInterval(this.keepAlive, 50000);

    })



    var currentTime = Math.floor(new Date().getTime() / 1000)
    var lastaccessTime = document.getElementById('lastaccess').value;
    var minutes = currentTime - lastaccessTime
    
   
      const time = (this.state.sessionExpiry - this.state.sessionPopBeforeTime) * 1000

      this.showPopupFunctionInterval = setInterval(this.showModal, time)

      window.addEventListener('mousemove', this.resetIdleTime, false)
      window.addEventListener('keypress', this.escFunction, false)
      document.addEventListener('keydown', this.escFunction, false);
  



  }

  escFunction(event) {
    if ((event.key == "F5" || event.key == 'Escape' || event.key == 'Control')) {
      event.preventDefault();
    }
  }
  resetIdleTime() {
    
    if (!this.state.showModal) {
//      console.log("in condition")


      this.setState({ idleTime: 0, lastaccessTime: Math.floor(new Date().getTime() / 1000) })


      clearInterval(this.showPopupFunctionInterval)

      this.showPopUpInterval()


      // clearInterval(this.showModal)
      // clearInterval(this.keepAlive)
      // setInterval(this.keepAlive, 50000);

      const time = (this.state.sessionExpiry - this.state.sessionPopBeforeTime) * 1000
     // console.log(this.state.sessionExpiry)
      //setInterval(this.showModal, time);
    }
  }

  showPopUpInterval() {

    const time = (this.state.sessionExpiry - this.state.sessionPopBeforeTime) * 1000

    this.showPopupFunctionInterval = setInterval(this.showModal, time)

  }

  checkIfIdle() {

    this.setState(prevState => ({
      lastaccessTime: Math.floor(new Date().getTime() / 1000)
    }), () => {

      //     if (this.state.idleTime >= 50000)
      // {

      clearInterval(this.idleInterval)

      // const time = (this.sessionExpiry - 120) * 1000

      //setInterval(this.showModal, time);
      //}  

    })



  }

  idleInterval() {

    setInterval(this.checkIfIdle, 1000);
  }

  keepAlive() {
    //if(!this.state.showModal) {

    var currentTime = Math.floor(new Date().getTime() / 1000)


    var idleTime = currentTime - this.state.lastaccessTime
   

    let sessionExpiry  = this.state.sessionExpiry

     if (idleTime > sessionExpiry) {

      this.signOut()
    } else {
      this.extendSession()
    }
  
  }
  signOut() {

    let baseUrl = '';
    if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
      baseUrl = document.getElementById('baseUrl').value;
    }

    window.location.href = `${baseUrl}/logoutAccount`;

  }

  extendSession() {


    let CityXHR = null;

    if (CityXHR !== null) {
      CityXHR.abort();
    }


    return new Promise((resolve, reject) => {
      CityXHR = new XMLHttpRequest();
      let baseUrl = '';
      if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
        baseUrl = document.getElementById('baseUrl').value;
      }

      let token = '';
      if (document.getElementById('tokenData') != 'undefined' && document.getElementById('tokenData') != null) {
        token = document.getElementById('tokenData').value;
      }


      CityXHR.open('POST', `${baseUrl}/api/extendSession/${token}`);

      CityXHR.onload = () => {
        if (CityXHR.status >= 200 && CityXHR.status < 300) {
          const data = JSON.parse(CityXHR.response);

          console.log('token extended')
          resolve(data);
        } else {
          reject(`status: ${CityXHR.status}, statusText: ${CityXHR.statusText}`);
        }
      };
      CityXHR.onerror = () => {
        reject(`status: ${CityXHR.status}, statusText: ${CityXHR.statusText}`);
      };
      CityXHR.send();
    });
  }


  okClick() {
    this.setState({ lastaccessTime: Math.floor(new Date().getTime() / 1000), showModal: false, showDimmer: false, isTimerStart: false })

    clearTimeout(this.signOutTimeOutFunction)

    this.keepALiveFunctionInterval = setInterval(this.keepAlive, 50000);

    this.showPopUpInterval()

    // const time = (this.state.sessionExpiry - this.state.sessionPopBeforeTime) * 1000

    // this.showPopupFunctionInterval = setInterval(this.showModal, time)
  }

  closeModal(e) {
    this.setState({ showModal: false, showDimmer: false, agentName: null })
    this.signOut();
  }
  showModal(e) {


    setTimeout(() => this.setState({ showModal: true, showDimmer: true, isTimerStart: true }), 1000);

    this.timer = setInterval(this.countDown, 1000);


    this.signOutTimeOutFunction = setTimeout(this.signOut, 120 * 1000);

    clearInterval(this.keepALiveFunctionInterval);
    clearInterval(this.showPopupFunctionInterval)
  }
  countDown() {
    // Remove one second, set state so a re-render happens.
    const seconds = this.state.seconds - 1;
    //console.log(seconds+"***")
    this.setState({
      time: this.secondsToTime(seconds),
      seconds,
    });

    // Check if we're at zero.
    if (seconds == 0) {
      clearInterval(this.timer);
      this.timer = 0;
      this.setState({
        seconds: this.state.timOutSeconds,
        isTimerStart: false,
      });
      this.setSecondToTime(this.state.timOutSeconds);
    }
  }

  setSecondToTime(seconds) {
    const timeLeftVar = this.secondsToTime(seconds);
    this.setState({ time: timeLeftVar });
  }
  secondsToTime(secs) {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    if (minutes == 1 && seconds < 10) {
      seconds = '0' + seconds;
    }

    const obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }

  render() {
    const { showModal, showDimmer, isTimerStart, time } = this.state;

    return (
      <>

        <Modal show={showModal} centered dialogClassName="my-3 ml-auto mr-auto px-4">
          <div className="shadow-none border-top-thick-red">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="p-4">
                  <div>                                {isTimerStart && time &&

                    <>
                      <button className="btn btn-dark btn-lg  font-size-md font-weight-500 border-0 font-size-md rounded-sm mx-1">{time.m}</button>
                      <button className="btn btn-dark btn-lg  font-size-md font-weight-500 border-0 font-size-md rounded-sm mx-1">{time.s}</button>
                    </>
                  }
                  </div>
                  <div className="row">

                    <div className="col-md-12">
                      <p className="mt-3 text-dark font-weight-500 mb-0">
                        You have been on this page for a while. For your security we will automatically log you out. Do you need more time?
                      </p>
                    </div>
                    <div className="col-md-12 mt-4">
                      <button className="btn-secondary px-4 py-2 btn text-white font-weight-500 mx-1" onClick={this.okClick}>
                        Yes
                      </button>
                      <button className="btn-secondary px-4 py-2 btn text-white font-weight-500 mx-1" onClick={this.closeModal}>
                        CANCEL
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }
}


export default SessionCheck;
